import { Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Stepper, Step } from "react-form-stepper";
import StepWizard from "react-step-wizard";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";
import animate from "../Vendor/animate.module.css";
import "../Vendor/wizard.css";
import { toast } from "react-hot-toast";
import {
  useFetchVendorsQuery,
} from "../../../features/admin/vendor/vendorApi";
import { useDispatch, useSelector } from "react-redux";
import { getUserPrograms } from "../../../utils/getUserPrograms";
import {
  createBoardObject,
  createColumsObject,
} from "../../../utils/createBoardObject";
import boardsSlice from "../../../features/admin/workflow/boardSlice";
import { useFetchRewardifyQuery } from "../../../features/admin/rewardify/rewardifyApi";
import { useFetchDwamQuery } from "../../../features/admin/dwam/dwamApi";
import { useFetchGenuinemarkQuery } from "../../../features/admin/genuinemark/genuinemarkApi";
import WorkflowBoard from "../../../components/Admin/WorkflowBoard";
import ReorderList from "../../../components/ReorderList/ReorderList";
import { useAddWorkflowMutation } from "../../../features/admin/workflow/workflowApi";
import { useNavigate } from "react-router-dom";

const ActionButtons = (props) => {
  const handleBack = () => {
    props.previousStep();
  };

  const handleNext = () => {
    props.nextStep();
  };

  const handleFinish = () => {
    props.lastStep();
  };

  return (
    <div className="mt-4">
      <div className="d-flex  justify-content-center align-items-center space-x-3 ">
        {props.currentStep > 1 && (
          <div>
            <Button
              startIcon={<IoArrowBackOutline />}
              variant="outlined"
              onClick={handleBack}
            >
              Back
            </Button>
          </div>
        )}
        <div>
          {props.currentStep < props.totalSteps && (
            <Button
              variant="outlined"
              endIcon={<IoArrowForwardOutline />}
              color="success"
              onClick={handleNext}
            >
              Next
            </Button>
          )}
          {props.currentStep === props.totalSteps && (
            <Button variant="contained" color="success" onClick={handleFinish}>
              Finish
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const BasicSetup = (props) => {
  const [vendorsList, setVendorsList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(0);
  const [selectedVendorData, setSelectedVendorData] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const [boardObject, setBoardObject] = useState(null);
  const [allProgramOptions, setAllProgramOptions] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [finalProgramList, setFinalProgramList] = useState(null);

  const dispatch = useDispatch();
  const boards = useSelector((state) => state.boards);

  console.log("workfloww daata 1", props.myData);

  const {
    data: vendorsData,
    isError: vendorsIsError,
    isLoading: vendorsIsLoading,
    error: vendorsError,
  } = useFetchVendorsQuery(sessionStorage.getItem("access_token")) || {};

  useMemo(() => {
    if (vendorsData) {
      (() => {
        setVendorsList(vendorsData.body);
      })();
    }
    if (vendorsError) {
      toast.error(vendorsError.error, {
        id: "vendorsError",
      });
    }
  }, [vendorsData, vendorsError]);

  const handleVendorChange = (event) => {
    setSelectedVendor(event.target.value);
    vendorsList.forEach(function (data) {
      if (data.company_id == event.target.value) {
        setSelectedVendorData(data);
        setUsersList(data.user_types);
      }
    });
  };

  const {
    data: dwamData,
    isError: dwamIsError,
    isLoading: dwamIsLoading,
    error: dwamError,
  } = useFetchDwamQuery(sessionStorage.getItem("access_token")) || {};

  const {
    data: rewardifyData,
    isError: rewardifyIsError,
    isLoading: rewardifyIsLoading,
    error: rewardifyError,
  } = useFetchRewardifyQuery(sessionStorage.getItem("access_token")) || {};

  const {
    data: genuinemarkData,
    isError: genuinemarkIsError,
    isLoading: genuinemarkIsLoading,
    error: genuinemarkError,
  } = useFetchGenuinemarkQuery(sessionStorage.getItem("access_token")) || {};

  useEffect(() => {
    toast.dismiss();
    // console.log(selectedUser , selectedVendor.product_availing);
    if (selectedUser && selectedVendorData.product_availing) {
      const selectedPrograms = getUserPrograms(
        selectedUser,
        selectedVendorData.product_availing,
      );
      if (allProgramOptions.length > 0 && selectedPrograms.length > 0) {
        // console.log("hereeeeee", selectedUser ,  selectedPrograms);
        const data = createBoardObject(selectedPrograms, allProgramOptions);
        setBoardObject(data);
        dispatch(boardsSlice.actions.initializeBoard(data));
      } else {
        if (selectedUser !== 0) {
          dispatch(
            boardsSlice.actions.initializeBoard([
              {
                columns: [],
                isActive: true,
              },
            ]),
          );
        }
      }
    } else {
      dispatch(
        boardsSlice.actions.initializeBoard([
          {
            columns: [],
            isActive: true,
          },
        ]),
      );
    }
  }, [selectedUser, selectedVendor]);

  useEffect(() => {
    if (dwamData?.body && rewardifyData?.body && genuinemarkData?.body) {
      const rdata = createColumsObject("Rewardify", rewardifyData.body);
      const dData = createColumsObject("DWAN", dwamData.body);
      const gData = createColumsObject("Genuinity", genuinemarkData.body);
      const data = [];
      data.push(rdata);
      data.push(dData);
      data.push(gData);
      setAllProgramOptions(data);
    }
  }, [dwamData, rewardifyData, genuinemarkData]);

  const basicSetupValidate = () => {
    const obj = {
      ...props.myData,
      selectedVendor: selectedVendor,
      selectedVendorData: selectedVendorData,
      selectedUser: selectedUser,
      boardObject: boardObject,
    };

    props.nextStep();
    props.vendorDataCallback(obj);
  };

  return (
    <div className="autox">
      <div className="cmxform formsstep_n1 width50 mt-4">
        <div className="row">
          <div className="col-12  my-2">
            <label className="text-capitalize font-weight-bold">
              Choose Client
            </label>
            <select
              className="js-example-basic-single w-100 rounded-lg shadow-sm shadow-black"
              value={selectedVendor}
              onChange={handleVendorChange}
            >
              <option value={0}>Select Client</option>
              {vendorsList &&
                vendorsList.map((vendor) => (
                  <option key={vendor.id} value={vendor.company_id}>
                    {vendor.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-12  mt-4">
            <label className="text-capitalize font-weight-bold">
              Choose User
            </label>
            <select
              className="js-example-basic-single w-100 rounded-lg shadow-sm shadow-black"
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value={0}>Select User</option>
              {usersList &&
                usersList.map((user, idx) => (
                  <option key={idx} value={user}>
                    {user}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>

      <ActionButtons {...props} nextStep={basicSetupValidate} />
    </div>
  );
};

const WorkflowSetup = (props) => {
  console.log("WorkflowSetup receive vendorData object");
  const [error, setError] = useState("");

  const [selectedVendor, setSelectedVendor] = useState(
    props.myData.selectedVendor,
  );
  const [selectedVendorData, setSelectedVendorData] = useState(
    props.myData.selectedVendorData,
  );
  const [selectedUser, setSelectedUser] = useState(props.myData.selectedUser);

  const [boardObject, setBoardObject] = useState(props.myData.boardObject);
  const boards = useSelector((state) => state.boards);

  console.log("WorkflowSetup", props.myData);

  useEffect(() => {
    setBoardObject(props.myData.boardObject);
    setSelectedVendor(props.myData.selectedVendor);
    setSelectedUser(props.myData.selectedUser);
    setSelectedVendorData(props.myData.selectedVendorData);
  }, [props]);

  const previewButton = () => {
    console.log(selectedUser, selectedVendorData);

    if (boards && selectedVendorData && selectedUser) {
      const board = boards.find((board) => board.isActive === true);

      const programs = [];
      const itemList = [];

      if (board.columns && board.columns[0] && board.columns[0].tasks) {
        board.columns[0].tasks.forEach((task) => {
          programs.push(task.title);
        });

        for (let i = 0; i < programs.length; i++) {
          const element = programs[i];
          itemList.push({
            id: element,
            order: i + 1,
          });
        }

        if (itemList.length > 0) {
          const obj = {
            ...props.myData,
            orderList: itemList,
            finalProgramList: itemList,
          };

          props.nextStep();
          props.vendorDataCallback(obj);
          return;
        }
      } else {
        toast.error("No Programs Selected for this user", {
          id: "noProgramsError",
        });
      }
    } else {
      return;
    }
  };

  //   const resetWorkflowBoard = () => {
  //     if (boards && selectedVendorData && selectedUser) {
  //       dispatch(boardsSlice.actions.initializeBoard(boardObject));
  //     } else {
  //       return;
  //     }
  //   };

  const setupValidate = () => {
    setError("");
    previewButton();
    // props.vendorDataCallback();
    // props.nextStep();
  };

  return (
    <div className="autox">
      <div className="cmxform px-5 mt-4">
        <div className="row " style={{ minHeight: "300px" }}>
          {boardObject && <WorkflowBoard />}
        </div>

        <div className="text-center mb-3" style={{ color: "red" }}>
          {error}
        </div>

        <ActionButtons {...props} nextStep={setupValidate} />
      </div>
    </div>
  );
};

const LastStep = (props) => {
  console.log("Last Step receive vendorData object");
  console.log(props.myData);

  const [selectedUser, setSelectedUser] = useState(
    props.myData?.selectedUser ? props.myData.selectedUser : null,
  );

  const [orderList, setOrderList] = useState(
    props.myData?.orderList ? props.myData.orderList : [],
  );
  const [finalProgramList, setFinalProgramList] = useState(
    props.myData?.finalProgramList ? props.myData.finalProgramList : [],
  );

  useEffect(() => {
    setSelectedUser(
      props.myData?.selectedUser ? props.myData.selectedUser : null,
    );
    setOrderList(props.myData?.orderList ? props.myData.orderList : []);
    setFinalProgramList(
      props.myData?.finalProgramList ? props.myData.finalProgramList : [],
    );
  }, [props]);

  const handleLastStep = () => {
    props.lastStep();
    props.completeCallback();
  };

  return (
    <div className="autox">
      <div className="cmxform  mt-4">
        <div className="w-100 d-flex flex-column justify-content-center align-items-center mb-4">
          <h2 className="titletxt">
            {selectedUser &&
              selectedUser.length > 0 &&
              selectedUser.charAt(0).toUpperCase() + selectedUser.slice(1)}{" "}
            Workflow
          </h2>
          <div className="col-md-6">
            {orderList.length > 0 && (
              <ReorderList list={orderList} setList={setFinalProgramList} />
            )}
          </div>
        </div>

        <ActionButtons {...props} lastStep={handleLastStep} />
      </div>
    </div>
  );
};

const WorkflowWizard = ({ handleClose, refetch }) => {
  const [stepWizard, setStepWizard] = useState(null);
  const [myData, setMyData] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const navigate = useNavigate();

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const assignvendorData = (val) => {
    console.log("parent receive myData callback");
    console.log(val);
    setMyData((myData) => ({
      ...myData,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    console.log("step change");
    console.log(e);
    setActiveStep(e.activeStep - 1);
  };

  const [
    addWorkflow,
    { data: workflowData, isLoading: workflowIsLoading, error: workflowError },
  ] = useAddWorkflowMutation();

  const handleComplete = () => {
    console.log(myData);

    console.log("Submit", myData.finalProgramList);
    const programs = [];
    myData.finalProgramList.forEach((each) => {
      programs.push(each.id);
    });

    var body = {
      tenant_id: myData.selectedVendorData.tenant_id,
      tenant_name: myData.selectedVendorData.name,
      industry_id: myData.selectedVendorData.industry_id,
      industry_name: myData.selectedVendorData.industry_name,
      user_type: myData.selectedUser,
      program: programs,
    };

    addWorkflow({
      token: sessionStorage.getItem("access_token"),
      body: body,
    });
  };
  const dispatch = useDispatch();

  const boards = useSelector((state) => state.boards);

  const resetWorkflowBoard = () => {
    if (boards && myData.selectedVendorData && myData.selectedUser) {
      dispatch(boardsSlice.actions.initializeBoard(myData.boardObject));
    } else {
      return;
    }
  };

  useEffect(() => {
    if (workflowIsLoading) {
      toast.loading("Creating workflow...", {
        id: "workflow-loading",
      });
    }

    if (workflowData) {
      toast.dismiss();
      toast.success(workflowData.message);
      handleClose();
      setMyData({});
      refetch((previous) => previous + 1);
    }

    if (workflowError) {
      toast.dismiss();

      toast.error(workflowError.data.message + " for this user", {
        id: "workflowError",
      });
      resetWorkflowBoard();
      handleClose();
    }
  }, [workflowData, workflowError, workflowIsLoading]);

  let custom = {
    enterRight: animate.fadeInRight,
    enterLeft: animate.fadeInLeft,
    exitRight: animate.fadeOutRight,
    exitLeft: animate.fadeOutLeft,
    intro: animate.animated,
  };
  return (
    <div>
      <Stepper activeStep={activeStep}>
        <Step
          label="Choose Client & User"
          children={
            <svg
              width="35px"
              height="35px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 9H14M18 12H14M12 15.5C11.7164 14.3589 10.481 13.5 9 13.5C7.519 13.5 6.28364 14.3589 6 15.5M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19ZM10 9.5C10 10.0523 9.55228 10.5 9 10.5C8.44772 10.5 8 10.0523 8 9.5C8 8.94772 8.44772 8.5 9 8.5C9.55228 8.5 10 8.94772 10 9.5Z"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
        />
        <Step
          label="Decide Workflow"
          children={
            <svg
              width="35px"
              height="35px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="🔍-Product-Icons"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="ic_fluent_phone_link_setup_24_regular"
                  fill="#212121"
                  fill-rule="nonzero"
                >
                  <path
                    d="M17.5,12 C17.7930736,12 18.0806075,12.024542 18.3607867,12.0717481 L18.5341163,12.7877987 C18.7930873,13.8615807 19.8734971,14.5221156 20.9472791,14.2631446 L21.0450624,14.2369258 L21.6461665,14.0580331 C22.0087308,14.5250263 22.2991223,15.0545692 22.4998264,15.6285394 L22.0525916,16.0588054 C21.2985339,16.7843546 21.2369524,17.9588704 21.8837443,18.7572658 L22.0250857,18.9142136 L22.4998264,19.3714606 C22.2992653,19.9450217 22.0091447,20.4742188 21.6469416,20.9409683 L21.0450624,20.7630742 C19.9857606,20.4500989 18.8733103,21.0551161 18.5603351,22.1144179 L18.5341163,22.2122013 L18.3607867,22.9282519 C18.0806075,22.975458 17.7930736,23 17.5,23 C17.2066096,23 16.918771,22.9754049 16.6383049,22.9280988 L16.4658837,22.2122013 C16.2069127,21.1384193 15.1265029,20.4778844 14.0527209,20.7368554 L13.9549376,20.7630742 L13.3530584,20.9409683 C12.9908553,20.4742188 12.7007347,19.9450217 12.5001736,19.3714606 L12.9474084,18.9411946 C13.7014661,18.2156454 13.7630476,17.0411296 13.1162557,16.2427342 L12.9749143,16.0857864 L12.5001736,15.6285394 C12.7007347,15.0549783 12.9908553,14.5257812 13.3530584,14.0590317 L13.9549376,14.2369258 C15.0142394,14.5499011 16.1266897,13.9448839 16.4396649,12.8855821 L16.4658837,12.7877987 L16.6383049,12.0719012 C16.918771,12.0245951 17.2066096,12 17.5,12 Z M13.75,2 C14.9926407,2 16,3.00735931 16,4.25 L16.0001627,11.1738934 C15.4723044,11.2985682 14.969311,11.4876006 14.4999221,11.7322512 L14.5,4.25 C14.5,3.83578644 14.1642136,3.5 13.75,3.5 L6.25,3.5 C5.83578644,3.5 5.5,3.83578644 5.5,4.25 L5.5,19.75 C5.5,20.1642136 5.83578644,20.5 6.25,20.5 L11.7327703,20.5010736 C12.0200482,21.0520148 12.3839565,21.5566422 12.8103588,22.0008195 L6.25,22 C5.00735931,22 4,20.9926407 4,19.75 L4,4.25 C4,3.00735931 5.00735931,2 6.25,2 L13.75,2 Z M8.74887095,17.5037644 L10.9999992,17.4989995 C10.9999992,18.0162111 11.0601751,18.5183676 11.1738934,18.9998373 L8.75112905,19.0037644 C8.33691596,19.0043862 8.00062441,18.6691057 7.99999915,18.2548926 C7.99937729,17.8406795 8.33465786,17.5043879 8.74887095,17.5037644 Z M17.5,16 C16.6993682,16 16.0503279,16.6715729 16.0503279,17.5 C16.0503279,18.3284271 16.6993682,19 17.5,19 C18.3006318,19 18.9496721,18.3284271 18.9496721,17.5 C18.9496721,16.6715729 18.3006318,16 17.5,16 Z"
                    id="🎨Color"
                  ></path>
                </g>
              </g>
            </svg>
          }
        />
        <Step
          label="Reorder & Confim"
          children={
            <svg
              fill="#000000"
              width="35px"
              height="35px"
              viewBox="0 0 32 32"
              enable-background="new 0 0 32 32"
              version="1.1"
              xmlSpace="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g id="Approved">
                <g>
                  <path d="M16,1C7.729,1,1,7.729,1,16s6.729,15,15,15s15-6.729,15-15S24.271,1,16,1z M16,29C8.832,29,3,23.168,3,16S8.832,3,16,3    s13,5.832,13,13S23.168,29,16,29z" />

                  <path d="M23.317,10.27l-10.004,9.36l-4.629-4.332c-0.403-0.377-1.035-0.356-1.413,0.047c-0.377,0.403-0.356,1.036,0.047,1.413    l5.313,4.971c0.192,0.18,0.438,0.27,0.683,0.27s0.491-0.09,0.683-0.27l10.688-10c0.403-0.377,0.424-1.01,0.047-1.413    C24.353,9.913,23.719,9.892,23.317,10.27z" />
                </g>
              </g>

              <g id="Approved_1_" />

              <g id="File_Approve" />

              <g id="Folder_Approved" />

              <g id="Security_Approved" />

              <g id="Certificate_Approved" />

              <g id="User_Approved" />

              <g id="ID_Card_Approved" />

              <g id="Android_Approved" />

              <g id="Privacy_Approved" />

              <g id="Approved_2_" />

              <g id="Message_Approved" />

              <g id="Upload_Approved" />

              <g id="Download_Approved" />

              <g id="Email_Approved" />

              <g id="Data_Approved" />
            </svg>
          }
        />
      </Stepper>
      <StepWizard
        instance={assignStepWizard}
        onStepChange={handleStepChange}
        transitions={custom}
      >
        <BasicSetup myData={myData} vendorDataCallback={assignvendorData} />

        <WorkflowSetup myData={myData} vendorDataCallback={assignvendorData} />
        <LastStep myData={myData} completeCallback={handleComplete} />
      </StepWizard>
    </div>
  );
};

export default WorkflowWizard;
